<div class="d-flex align-items-center ps-75">
    <label class="switch position-relative d-inline-block mb-0">
      <input type="checkbox" [(ngModel)]="isActive"  (ngModelChange)="onToggleChange($event)" />
      <span class="slider position-absolute top-0 d-flex align-items-center justify-content-between">
      </span>
    </label>
</div>